import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const childrenPropTypes = (extraTypes = []) => PropTypes.oneOfType([
  PropTypes.element,
  PropTypes.node,
  PropTypes.arrayOf(PropTypes.element),
  PropTypes.arrayOf(PropTypes.node),
  ...extraTypes,
]);
